export default __webpack_public_path__ + "static/media/cow_chicken_grayscale.9bef6007.svg";